// downloadTripDataAsExcel.js
import * as XLSX from 'xlsx';

export const downloadTripDataAsExcel = (tripList) => {
  const { rows, merges } = formatTripData(tripList);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(rows);

  // Set column widths (now 12 columns)
  ws['!cols'] = [
    { wch: 8 },   // Sl.No
    { wch: 20 },  // Driver Name
    { wch: 15 },  // Cab Number
    { wch: 12 },  // Mobile num
    { wch: 25 },  // Emp Name
    { wch: 12 },  // PH Num
    { wch: 20 },  // Company
    { wch: 20 },  // Area
    { wch: 12 },  // Pickup Time
    { wch: 20 },  // Drop Location
    { wch: 12 },  // Vehicle Type
    { wch: 12 },  // Trip Type
  ];

  // Add merge ranges (provided by formatter)
  ws['!merges'] = merges;

  // Apply styles to all cells (unchanged)
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    const isHeaderRow = R === 0;
    const isDriverRow = ws[XLSX.utils.encode_cell({ r: R, c: 0 })]?.v?.toString().startsWith('Cab');

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cellRef]) ws[cellRef] = { v: '' };

      const cellStyle = {
        alignment: { vertical: 'center', horizontal: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
        },
        font: { name: 'Arial', sz: 10 },
      };

      if (isHeaderRow) {
        cellStyle.fill = { fgColor: { rgb: 'FFFF00' } };
        cellStyle.font = { ...cellStyle.font, bold: true, sz: 11 };
      }
      if (isDriverRow) {
        cellStyle.fill = { fgColor: { rgb: 'FFFF99' } };
      }
      if (!isHeaderRow && !isDriverRow) {
        cellStyle.fill = { fgColor: { rgb: 'FFFFCC' } };
      }

      ws[cellRef].s = cellStyle;
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, 'Trip Data');
  XLSX.writeFile(wb, `Trip_Data_${new Date().toISOString().split('T')[0]}.xlsx`);
};

// Add Company, Vehicle Type, Trip Type columns and merge trip-level fields
const formatTripData = (tripList) => {
  const headers = [
    'Sl.No',
    'Driver Name',
    'Cab Number',
    'Mobile num',
    'Emp Name',
    'PH Num',
    'Company',
    'Area',
    'Pickup Time',
    'Drop Location',
    'Vehicle Type',
    'Trip Type',
  ];
  const rows = [headers];
  const merges = [];

  let currentRow = 1;
  let cabCounter = 1;

  tripList.forEach((trip, tripIndex) => {
    const employeeCount = trip.liveTrackingData.length;
    if (employeeCount === 0) return;

    // Merge per-trip columns across employee rows
    if (employeeCount > 1) {
      // Sl.No, Driver, Cab, Mobile
      merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow + employeeCount - 1, c: 0 } });
      merges.push({ s: { r: currentRow, c: 1 }, e: { r: currentRow + employeeCount - 1, c: 1 } });
      merges.push({ s: { r: currentRow, c: 2 }, e: { r: currentRow + employeeCount - 1, c: 2 } });
      merges.push({ s: { r: currentRow, c: 3 }, e: { r: currentRow + employeeCount - 1, c: 3 } });
      // Vehicle Type, Trip Type
      merges.push({ s: { r: currentRow, c: 10 }, e: { r: currentRow + employeeCount - 1, c: 10 } });
      merges.push({ s: { r: currentRow, c: 11 }, e: { r: currentRow + employeeCount - 1, c: 11 } });
    }

    // Employee rows
    trip.liveTrackingData.forEach((employee, index) => {
      const row = [
        index === 0 ? `Cab ${cabCounter}` : '',
        index === 0 ? trip.driverName : '',
        index === 0 ? trip.vehicleNo : '',
        index === 0 ? trip.driverNumber : '',
        employee.employee.employeeName,
        employee.employee.mobileNumber,
        employee.employee.company?.name ?? '',
        employee.pickupLocation,
        employee.pickupTime,
        employee.dropLocation,
        index === 0 ? trip.vehicleType : '',
        index === 0 ? trip.tripType : '',
      ];
      rows.push(row);
      currentRow++;
    });

    // Spacer row between groups
    if (tripIndex < tripList.length - 1) {
      rows.push(Array(12).fill(''));
      currentRow++;
    }

    cabCounter++;
  });

  return { rows, merges };
};
